import {ClusterNodeUI, createClusterNodeInstances} from "./cluster-nodeUI";
import Utils from "../../../utils/utils";


class ClusterNode {
  public constructor(private ui: ClusterNodeUI) {
    window.addEventListener("socketData", (event: CustomEvent<any>) => {
      if (event.detail.id === this.ui.getServerId()) {
        if (event.detail.type === "stateChanged") {
          this.ui.updateState(event.detail.data.state);
        }
      }
    });
    
    this.ui.onButtonClick((url: string, button: JQuery) => Utils.handleButtonClick(url, button));
  }
}

export function initClusterNode() {
  $('.ajax-button').each((index, el) => {
    Utils.onCustomButtonClick($(el), (url: string, button: JQuery) => Utils.handleButtonClick(url, button));
  });
  
  return createClusterNodeInstances().map((item, index) => {
    return new ClusterNode(item);
  });
}
